export const preloadImages = (imagesObj) => {
  return Object.values(imagesObj).map((src) => {
    const img = new Image();
    img.src = src;
    return img;
  });
};
